import { lazyNamed } from 'src/utils/lazyNamed.ts';

export { AdMedias } from './containers/AdMedias/index.ts';
export { Placements } from './containers/Placements/index.ts';
export { AdTypes } from './containers/AdTypes/index.ts';
export { Products } from './containers/Products/index.ts';
export { AdPrices } from './containers/AdPrices/index.ts';
export { Calendars } from './containers/Calendars/index.ts';
export { SizeConfigs } from './containers/SizeConfigs/index.ts';
export { Availabilities } from './containers/Availabilities/index.ts';

export const Layout = lazyNamed(() => import('./components/Layout.tsx'), 'Layout');
